module.exports = __webpack_public_path__ + "img/small-2.ba3ec246.webp";